export const BREAKPOINTS = {
  maxDesktop: 1400,
  minDesktop: 1200,
  maxTablet: 1120,
  desktop: 1000,
  tablet: 768,
  home: {
    wideScreen: 1600,
  },
  // mobile from 0 to tablet
};

export const getContentHeightCss = (padding = 0) => {
  return `calc(100vh - ${100 + padding}px)`;
};

export const PERIOD_MONTH = 'month';
export const PERIOD_YEAR = 'year';

export const PERIODS = [
  { label: 'Monthly', value: PERIOD_MONTH },
  { label: 'Yearly', value: PERIOD_YEAR },
];

export const CURRENCIES = [
  { label: 'USD', value: 'usd', symbol: '$' },
  { label: 'AUD', value: 'aud', symbol: '$' },
  { label: 'EUR', value: 'eur', symbol: '€' },
  { label: 'GBP', value: 'gbp', symbol: '£' },
];

export const CURRENCIES_SYMBOL = CURRENCIES.reduce((acc: any, curr) => {
  acc[curr.value] = curr.symbol;

  return acc;
}, {});

export const INSTAGRAM_ACCOUNTS_OPTIONS = [
  { label: '1', value: '1', recommended: 'Fundamentals' },
  { label: '2-4', value: '2-4', recommended: 'Essentials' },
  { label: '5-8', value: '5-8', recommended: 'Professional' },
  { label: '9-15', value: '9-15', recommended: 'Enterprise' },
  { label: '16-24', value: '16-24', recommended: 'Enterprise' },
  { label: '25+', value: '25+', recommended: 'Enterprise' },
];

export const INDUSTRIES = [
  { label: 'Fashion/Retail', value: 'Fashion/Retail' },
  { label: 'E-commerce', value: 'E-commerce' },
  { label: 'Agency', value: 'Agency' },
  { label: 'Hospitality/Tourism/Travel', value: 'Hospitality/Tourism/Travel' },
  { label: 'Solo Social Media Manager', value: 'Solo Social Media Manager' },
  { label: 'Other', value: 'Other' },
];
